import { render } from "./ConstructionView.vue?vue&type=template&id=457b35fe"
import script from "./ConstructionView.vue?vue&type=script&lang=js"
export * from "./ConstructionView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__